import Markdown from 'react-markdown';

const TextAreaSmall = (props) => {
    const { text, styleRules } = props;
    return(
        <div className={`text_area_small${ styleRules?.mod?` ${styleRules.mod}`:''}`}>
            <Markdown>
                { text }
            </Markdown>
        </div>)
}

export default TextAreaSmall;